import { createContext } from "react";
import { IDetails } from "../../pages/HMI/HMIDashboard/components/Details/DetailsAPIInterfaces";
import { IContextState, IEventsEditionsPending, IManualQualityPendingEntry } from "./HMICachedDataContextInterfaces";
import { IClusterStore } from "contexts/ClusterCachedDataContext/ClusterCachedDataContextInterfaces";
import { DEFAULT_INACTIVITY_ALERT_DELAY_CLUSTER_HMI, DEFAULT_INACTIVITY_LIMIT_CLUSTER_HMI } from "constants/constants";
import {
    getDataLastUpdatedDateHMIStore,
    getDefaultUptimeValuesHMIStore,
    getEditionsPendingHMIStore,
    getEventReportEditData,
    getEventReportEditing,
    getFailureTypesHMIStore,
    getLastTwoShiftEventsHMIStore,
    getMachineCenterHMIStore,
    getManualQualityPendingHMIStore,
    getMQTTBrokerSettingsHMIStore,
} from "utilities/storageUtilities";

const machineCenterLocalStorage = getMachineCenterHMIStore();
const failureTypesLocalStorage = getFailureTypesHMIStore();
const eventReportEditingLocalStorage = getEventReportEditing();
const mqttBrokerSettingsLocalStorage = getMQTTBrokerSettingsHMIStore();
const lastTwoShiftEventsLocalStorage = getLastTwoShiftEventsHMIStore();
const defaultUptimeValuesLocalStorage = getDefaultUptimeValuesHMIStore();
const eventReportEditDataLocalStorage = getEventReportEditData();
const dataLastUpdatedDateLocalStorage = getDataLastUpdatedDateHMIStore();
const editionsPendingDataLocalStorage = getEditionsPendingHMIStore();
const manualQualityPendingDataLocalStorage = getManualQualityPendingHMIStore();

export const eventReportData = {
    row: {
        event_report_id: 0,
        end_date: "",
        start_date: "",
        failure_code: {
            failure_code_id: 0,
            name: "",
            default_failure_code_translations: [],
        },
        failure_type: {
            failure_type_id: 0,
            name: "",
            is_location_specific: true,
            color_code: "",
            failure_codes: [],
            default_failure_type_translations: [],
        },
        duration: "",
        area: {
            area_id: 0,
            translation: {
                id: 0,
                translation_names: [],
            },
            functional_locations: [],
        },
        functional_location: {
            functional_location_id: 0,
            translation: {
                id: 0,
                translation_names: [],
            },
        },
        RCA_triggered: "",
        user_operator: {
            user_id: 0,
            first_name: "",
            last_name: "",
        },
        notes: "",
        cluster_id: 0,
        cluster: {
            inactivity_time_limit: DEFAULT_INACTIVITY_LIMIT_CLUSTER_HMI,
            inactivity_alert_delay: DEFAULT_INACTIVITY_ALERT_DELAY_CLUSTER_HMI,
        },
        created_at: new Date(),
    },
};

export const initialStateHMICachedDataContext: IContextState = {
    store: {
        machineCenter: machineCenterLocalStorage,
        failureTypes: failureTypesLocalStorage || [],
        apolloQueryError: undefined,
        isEventReportEditing: Boolean(eventReportEditingLocalStorage),
        editEventReportData: { row: eventReportEditDataLocalStorage },
        lastUpdated: dataLastUpdatedDateLocalStorage || new Date(),
        lastTwoShiftsEventReports: lastTwoShiftEventsLocalStorage,
        mqttBrokerSettings: mqttBrokerSettingsLocalStorage,
        defaultUptimeValues: defaultUptimeValuesLocalStorage,
        editionsPending: editionsPendingDataLocalStorage || {},
        manualQualityPending: manualQualityPendingDataLocalStorage || {},
    },
    dispatch: {
        GetData: async (machine_center_id: number, login?: boolean) => {},
        resetStore: () => {},
        editEventReportData: (row: IDetails | undefined) => {},
        isEventReportEditing: (isEditing: boolean) => {},
        handleMoveToCluster: (clusterStore: IClusterStore, machineCenterId: number) => {},
        trackEventEdition: (eventId: number, data: IEventsEditionsPending[0]) => {},
        trackPendingManualQuality: (entry: IManualQualityPendingEntry) => {},
        markPendingManualQualityAcked: (key: string) => {},
        clearPendingManualQuality: (key: string) => {},
    },
};

export const HMICachedDataContext = createContext(initialStateHMICachedDataContext);
